import { render } from "./BagicEditor.vue?vue&type=template&id=8a3ac432&scoped=true"
import script from "./BagicEditor.vue?vue&type=script&lang=js"
export * from "./BagicEditor.vue?vue&type=script&lang=js"

import "./BagicEditor.vue?vue&type=style&index=0&id=8a3ac432&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3ac432"]])

export default __exports__